import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../../http';
import { toApiError } from '../utils';

export const useDeleteHierarchy = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async (hierarchyId: string) => {
			try {
				await api.delete(`/hierarchy/delete/${hierarchyId}`);
			} catch (error) {
				throw toApiError(error, 'Erro ao excluir hierarquia');
			}
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['hierarchies'] });
		},
	});
};
